import React, { useState } from "react";
import ham from "../assets/ham.png";
import close from "../assets/close.svg";
import logo2 from "../assets/logo dark.png";
import { motion } from "framer-motion";

function Navbar() {
  const [openModal, setOpenModal] = useState(false);

  function hamburger() {
    setOpenModal(true);
  }

  function closeHamburger() {
    setOpenModal(false);
  }

  return (
    <nav className="shadow-2xl px-[20px] md:px-[50px] ">
      <div className="  bg-inherit pt-[5px] md:pt-[10px] flex items-center justify-between pb-[10px]">
        <motion.img
          src={logo2}
          alt=""
          className="w-[100px]"
          initial={{ y: -250 }}
          animate={{ y: 0 }}
          transition={{
            type: "spring",
            stiffness: 300,
          }}
        />
        <div className="gap-[20px] hidden md:flex items-center">
          <ul className="flex gap-[20px] items-center">
            <motion.li
              whileHover={{ scale: 1.1, color: "white", originX: 0 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <a href="#about">About</a>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1, color: "white", originX: 0 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <a href="#experience">Experience</a>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1, color: "white", originX: 0 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <a href="#projects">Projects</a>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1, color: "white", originX: 0 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <a href="#contact">Contact</a>
            </motion.li>
          </ul>
          <motion.a
            href="https://drive.google.com/file/d/1ivRwRVOyuyloQCpdJzq-lTDNjj56gqHK/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
            className="border border-solid border-white rounded-lg px-[30px] py-[10px] hover:bg-gray-800 "
            transition={{ type: "spring", stiffness: 250 }}
            whileHover={{
              scale: 1.1,
              textShadow: "0px 0px 8px rgb(255, 255, 255)",
              boxShadow: "0px 0px 8px rgb(255, 255, 255)",
            }}
          >
            Resume
          </motion.a>
        </div>
        <button onClick={hamburger} className="md:hidden">
          <img
            src={ham}
            alt=""
            className="  w-[20px] "
            style={{ color: "blue" }}
          />
        </button>
        {/* open hamburger modal */}
        {openModal && (
          <div className=" bg-[#112240] flex flex-col gap-[20px] items-center  w-[50%] p-[20px] absolute top-0 z-10 right-0 rounded-lg md:hidden">
            <button onClick={closeHamburger} className="ml-[90%] ">
              <img src={close} alt="" className="w-[20px] " />
            </button>
            <ul className="flex flex-col gap-[20px] items-center text-xs md:text-base">
              <motion.li whileHover={{ scale: 1.1, color: "white" }}>
                <a href="#about">About</a>
              </motion.li>
              <motion.li whileHover={{ scale: 1.1, color: "white" }}>
                <a href="#experience">Experience</a>
              </motion.li>
              <motion.li whileHover={{ scale: 1.1, color: "white" }}>
                <a href="#projects">Projects</a>
              </motion.li>
              <motion.li whileHover={{ scale: 1.1, color: "white" }}>
                <a href="#contact">Contact</a>
              </motion.li>
            </ul>
            <motion.a
              href="https://drive.google.com/file/d/1ivRwRVOyuyloQCpdJzq-lTDNjj56gqHK/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
              className="border border-solid border-white   rounded-[6px] hover:bg-gray-800 mt-[3%] text-xs text-center py-[5px] px-[10px] "
              transition={{ type: "spring", stiffness: 250 }}
              whileHover={{
                scale: 1.1,
                textShadow: "0px 0px 8px rgb(255, 255, 255)",
                boxShadow: "0px 0px 8px rgb(255, 255, 255)",
              }}
            >
              Resume
            </motion.a>
          </div>
        )}
      </div>
      {openModal && (
        <div className="overlay z-[2] w-[100%] h-full bg-gray-900 absolute top-0 left-0 opacity-[0.5] md:hidden"></div>
      )}
    </nav>
  );
}

export default Navbar;
